import type { MouseEvent } from 'react';
import type { NavigateFunction } from 'react-router-dom';

export type UseWorkoutLibraryModalsParams = {
  workouts: { id: string; name: string }[];
  navigate: NavigateFunction;
  setOpenWorkoutMenu: (id: string | null) => void;
};

/** Workout library navigation — row click, edit route, create route. */
export function useWorkoutLibraryModals({
  workouts,
  navigate,
  setOpenWorkoutMenu,
}: UseWorkoutLibraryModalsParams) {
  const checkWorkoutNameExists = (name: string, excludeWorkoutId?: string): boolean => {
    const trimmedName = name.trim();
    if (!trimmedName) return false;
    return workouts.some(
      (workout) =>
        workout.name.trim().toLowerCase() === trimmedName.toLowerCase() &&
        workout.id !== excludeWorkoutId,
    );
  };

  const handleWorkoutClick = (workout: { id?: string }, e?: MouseEvent) => {
    if (e) {
      const target = e.target as HTMLElement;
      if (
        target.closest('.workout-menu') ||
        target.closest('input[type="checkbox"]') ||
        target.closest('.workout-menu-item')
      ) {
        return;
      }
    }
    if (!workout?.id) return;
    navigate(`/trainer-dashboard/workout/${workout.id}`);
  };

  const handleEditWorkout = async (workout: { id?: string }) => {
    if (!workout?.id) return;
    setOpenWorkoutMenu(null);
    navigate(`/trainer-dashboard/workout/${workout.id}?mode=edit`);
  };

  const handleCreateNewWorkout = () => {
    navigate('/trainer-dashboard/workout/new');
  };

  return {
    checkWorkoutNameExists,
    handleWorkoutClick,
    handleEditWorkout,
    handleCreateNewWorkout,
  };
}
